export const API_BASE_URL = (() => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'local':
      return process.env.REACT_APP_LOCAL_ENDPOINT;
    case 'staging':
      return process.env.REACT_APP_STAGING_ENDPOINT;
    case 'production':
      return process.env.REACT_APP_PRODUCTION_ENDPOINT;
    default:
      throw new Error('REACT_APP_ENVIRONMENT is not set to a valid value (local, staging, or production). Please check your .env file.');
  }
})();

export const API_ENDPOINTS = {
  LEADS: '/leads',
  PROJECTS: '/projects',
  PROJECT_DETAIL: (slug) => `/projects/${slug}`,
  PROJECT_SKILLS: (slug) => `/projects/${slug}/skills`,
  BLOGS: '/blogs',
  BLOG_DETAIL: (slug) => `/blogs/${slug}`,
  BLOG_CATEGORIES: (slug) => `/blogs/${slug}/categories`,
  BLOGS_BY_CATEGORY: (slug) => `/categories/${slug}/blogs`,
  BLOG_CATEGORIES_WITH_BLOGS: '/blog-categories-with-blogs',
  BLOG_CATEGORY_DETAIL: (slug) => `/blog-categories/${slug}`, // Added this line
  TESTIMONIALS: '/testimonials',
  FAQS: '/faqs',
  SERVICES: '/services',
  SERVICE_DETAIL: (slug) => `/services/${slug}`,
  WORK_EDUCATION: '/work-education',
  SEO_SETTINGS: (pageKey) => `/seo-settings/${pageKey}`,
  ALL_SETTINGS: '/settings',
  SETTINGS: (key) => `/settings/${key}`,
  TERMS_CONDITIONS: '/terms-conditions',
  PRIVACY_POLICY: '/privacy-policies',
  CLIENTS: '/clients',
  HEADER_FOOTERS: '/header-footers',
  ADMIN_NEWSLETTER_SUBSCRIBERS: '/newsletter-subscribers', // New endpoint for admin
};

export const MODAL_HIDE_DURATION_MS = 30 * 24 * 60 * 60 * 1000;
export const MODAL_LAST_SHOWN_KEY = 'contactModalLastShown';

export const SETTING_KEYS = {
  SITE_NAME: 'site_name',
  FAVICON: 'favicon',
};